// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"177":"home","470":"moban","535":"login"}[chunkId] + "." + {"177":"9beafa01","470":"5d4c3725","535":"6fe52408"}[chunkId] + ".js";
};